var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9199,
    cy: 21.2583,
    r: 20.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9199 16.3755L17.0371 15.2583L21.9056 20.1268L26.8027 15.2583L27.9199 16.3755L23.0514 21.244L27.9199 26.1411L26.8027 27.2583L21.9056 22.3898L17.0371 27.2583L15.9199 26.1411L20.7884 21.244L15.9199 16.3755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9761 20.1977L26.8025 15.3995L27.7785 16.3755L22.9807 21.1733L22.9102 21.2438L22.9805 21.3145L27.7787 26.1409L26.8025 27.1171L21.9761 22.3189L21.9054 22.2486L21.8349 22.3191L17.0371 27.1169L16.0611 26.1409L20.8593 21.3145L20.9296 21.2438L20.8591 21.1733L16.0613 16.3755L17.0371 15.3997L21.8349 20.1975L21.9054 20.268L21.9761 20.1977Z",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.33f4d3af75018f68f6593da141210365.svg";
export { ForwardRef as ReactComponent };